<div class="image_properties">
    <small class="debug">{{ me }}</small>
    <mat-label>
        <div>
            <mat-icon style="position: relative; left: -15px; top: 10px; font-size: 20px">image</mat-icon>
            <span style="position: relative; left: -10px">{{ 'placeholder.resourceType' | transloco }} : {{ resource?.resource_type }}</span>
        </div>
    </mat-label>
    <br/>
    <mat-form-field>
        <mat-label>{{ 'placeholder.resourceName' | transloco }}</mat-label>
        <input inputrestriction="basic1" #resourceNameId matInput (keyup)="updateResourceProperty($event)" placeholder="" value="{{resource?.resource_name}}">
    </mat-form-field>
</div>
